"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRow = exports.CompanyCardsWrapper = exports.SpinnerWrapper = exports.TextWrapper = exports.CompanySubscriptionsStepWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const antd_1 = require("antd");
exports.CompanySubscriptionsStepWrapper = styled_components_1.default.div `
	width: 100%;
	max-width: 1000px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.TextWrapper = styled_components_1.default.div `
	font-size: 1.2rem;
	max-width: 800px;
	text-align: center;
	margin-top: 0.5rem;
	margin-bottom: 1.5rem;
	color: ${props => props.theme.color.gray6};
`;
exports.SpinnerWrapper = styled_components_1.default.div `
	text-align: center;
	margin: 6rem 0;
`;
exports.CompanyCardsWrapper = styled_components_1.default.div `
	position: relative;
`;
exports.StyledRow = (0, styled_components_1.default)(antd_1.Row) `
	padding: 2rem;
	background-color: ${props => props.theme.color.gray1};
	border-radius: 8px;
	max-height: 380px;
	${(0, styled_breakpoints_1.down)('lg')} {
		overflow-y: scroll;

		// todo uncomment and improve fading in scrollable area

		/* &::before {
			content: '';
			position: absolute;
			display: block;
			top: 0;
			height: 30px;
			width: 100%;
			pointer-events: none;
			background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
		}

		&::after {
			content: '';
			position: absolute;
			display: block;
			bottom: 0;
			height: 30px;
			width: 100%;
			pointer-events: none;
			background: linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
		} */
	}

	${(0, styled_breakpoints_1.down)('sm')} {
		max-height: calc(100vh - 305px);
	}

	${(0, styled_breakpoints_1.down)('xs')} {
		padding: 1rem 0;
	}
`;
